import * as React from "react";
import { ListItemAvatar, styled } from "@mui/material";
import { GenderValue } from "shared";
import { MaleFemaleIcon } from "../patientChart/PatientCaseContainer";

import MaleIcon from "../../../assets/maleIcon.svg";
import FemaleIcon from "../../../assets/femaleIcon.svg";
import UnknownGenderIcon from "../../../assets/unknownGenderIcon.svg";

//region [[ Styles ]]
const CaseGenderIconView = styled(ListItemAvatar)({
  marginTop: "-3px",
  "& img": {
    height: "55px",
  },
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface CaseGenderIconProps {
  className?: string;
  gender: any;
  onClick?: () => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const CaseGenderIcon = ({ ...props }: CaseGenderIconProps) => {
  const genderIcon =
    props.gender === GenderValue.MALE
      ? MaleIcon
      : props.gender === GenderValue.FEMALE
      ? FemaleIcon
      : UnknownGenderIcon;

  return (
    <CaseGenderIconView className={props.className}>
      <MaleFemaleIcon
        onClick={props.onClick}
        src={genderIcon}
        // height={props.height || "55"}
      />
    </CaseGenderIconView>
  );
};
